import angular from "angular"

angular
  .module("fichaAlumnoModule")
  .controller("FormularioAtencionAsistenciaController", FormularioAtencionAsistenciaController)
  .controller("FormularioAtencionEstadoController", FormularioAtencionEstadoController)
  .controller("FormularioAtencionController", FormularioAtencionController)
  .controller("FormularioEliminarAtencionesController", FormularioEliminarAtencionesController)

FormularioAtencionAsistenciaController.$inject = [
  "$scope",
  "$mdDialog",
  "DTOptionsBuilder",
  "saveCallback",
  "models"
]
function FormularioAtencionAsistenciaController(
  $scope,
  $mdDialog,
  DTOptionsBuilder,
  saveCallback,
  models
) {
  var self = $scope

  self.rows = models

  for (var i = 0; i < self.rows.length; i++) {
    self.rows[i].asiste = self.rows[i].asistencia
  }

  self.dtOptions = DTOptionsBuilder.newOptions()
    .withLanguage({
      sProcessing: "Procesando...",
      sLengthMenu: "Mostrar _MENU_ registros",
      sZeroRecords: "No se seleccionaron registros",
      sEmptyTable: "No se seleccionaron registros",
      sInfo: "_START_ a _END_ de _TOTAL_",
      sInfoEmpty: "",
      sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
      sInfoPostFix: "",
      sSearch: "",
      sUrl: "",
      sInfoThousands: ".",
      sLoadingRecords: "Cargando...",
      oPaginate: {
        sFirst: "|<",
        sLast: ">|",
        sNext: ">",
        sPrevious: "<"
      },
      oAria: {
        sSortAscending: ": Activar para ordenar la columna de manera ascendente",
        sSortDescending: ": Activar para ordenar la columna de manera descendente"
      }
    })
    .withPaginationType("simple")
    .withDisplayLength(25)
    .withOption("scrollY", "150px")
    .withOption("scrollX", "100%")
    // .withDOM('trp');
    .withDOM('<"menu-imp-exp">t')

  self.confirmar = function() {
    saveCallback(self.rowsDirty())
    self.cancelar()
  }

  self.reloadTable = function() {
    // self.rows = [1,2];
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }

  self.rowsDirty = function() {
    var dirty = []
    for (var i = 0; i < self.rows.length; i++) {
      if (!self.rows[i].asiste) {
        self.rows[i].asiste = false
      }
      dirty.push({ id: self.rows[i].id, asistencia: self.rows[i].asiste })
    }
    return dirty
  }

  self.toggle = function(row) {
    if (!row.asiste) {
      row.asiste = true
    } else {
      row.asiste = !row.asiste
    }
  }
}

FormularioAtencionEstadoController.$inject = [
  "$scope",
  "$mdDialog",
  "saveCallback",
  "models",
  "UserService",
  "notificarService",
  "ComentarioService"
]
function FormularioAtencionEstadoController(
  $scope,
  $mdDialog,
  saveCallback,
  models,
  UserService,
  notificarService,
  ComentarioService
) {
  var self = $scope

  self.row = models[0]

  self.registrarAsistencia = false
  self.atencionRealizada = self.row.estado
  self.informarUsuario = false
  self.comentario = ""
  self.usuario_id = -1

  UserService.get().$promise.then(function(data) {
    self.responsables = data.results
  })

  self.confirmar = function() {
    var data
    var callbackPromise
    var comment

    self.row.estado = self.atencionRealizada
    self.row.asistencia = self.registrarAsistencia

    data = {
      realizado: self.atencionRealizada,
      asistencia: self.registrarAsistencia,
      usuario_id: self.usuario_id,
      comentario: self.comentario,
      subject: "cierre_atencion",
      row: self.row
    }

    if (self.informarUsuario && self.usuario_id != -1) {
      //enviar datos de correo a una URL con envio de correo
      notificarService.notificar(data)
    }

    if (self.comentario !== "") {
      comment = {
        object_pk: self.row.id,
        modelName: "evento",
        comment: self.comentario
      }
      callbackPromise = function() {
        return ComentarioService.save(comment).$promise
      }
    }

    saveCallback([self.row], callbackPromise)
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }

  self.toggle = function(row) {
    if (!row.realizado) {
      row.realizado = true
    } else {
      row.realizado = !row.realizado
    }
  }
}

FormularioAtencionController.$inject = [
  "$scope",
  "$mdDialog",
  "$filter",
  "CategoriaService",
  "PlanAccionService",
  "UserService",
  "saveCallback",
  "permissionService"
]
function FormularioAtencionController(
  $scope,
  $mdDialog,
  $filter,
  CategoriaService,
  PlanAccionService,
  UserService,
  saveCallback,
  permissionService
) {
  var self = $scope

  self.isLoading = false

  self.atencion = {
    accion_id: null,
    categoria_id: null,
    tarea_id: null,
    sesiones: [
      {
        fecha_limite: new Date(),
        responsable_id: null
      }
    ]
  }

  self.addSessionRow = function() {
    self.atencion.sesiones.push({
      fecha_limite: new Date(),
      responsable_id: null
    })
  }

  self.removeSessionRow = function(index) {
    self.atencion.sesiones.splice(index, 1)
  }

  self.sessionIsAgendable = function(categoria, accion, tarea) {
    return (
      this.attentionTreeIsSetted(categoria, accion, tarea) &&
      this.everySessionHasResponsible() &&
      !this.dateAndUserRowRepeated()
    )
  }

  self.attentionTreeIsSetted = function(categoria, accion, tarea) {
    return categoria && accion && tarea ? true : false
  }

  self.everySessionHasResponsible = function() {
    let responsiblesSetted = true

    self.atencion.sesiones.map(session => {
      if (!session.responsable_id) responsiblesSetted = false
    })

    return responsiblesSetted
  }

  self.dateAndUserRowRepeated = function() {
    let rowIsRepeated = false

    self.atencion.sesiones.map((session1, index1) => {
      self.atencion.sesiones.map((session2, index2) => {
        if (index1 !== index2) {
          if (
            session1.responsable_id &&
            session2.responsable_id &&
            session1.responsable_id === session2.responsable_id &&
            this.datesAreEqual(session1.fecha_limite, session2.fecha_limite)
          ) {
            rowIsRepeated = true
          }
        }
      })
    })

    return rowIsRepeated
  }

  self.datesAreEqual = function(date1, date2) {
    return (
      date1.getDay() === date2.getDay() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    )
  }

  self.acciones = []
  self.tareasSelect = []

  self.marcarRealizado = false
  self.registrarAsistencia = true
  self.notificarResponsable = permissionService.editarSoloAtencionesMasivas() ? false : true

  self.enablePlanes = false

  self.categoria_id = null

  self.comentario = ""

  self.loadPlanes = function(params) {
    PlanAccionService.get(params).$promise.then(function(data) {
      self.acciones = data.results
      self.planes_dict = {}

      angular.forEach(self.acciones, function(value, key) {
        self.planes_dict[value.id] = value
      })
    })
  }

  CategoriaService.get().$promise.then(function(data) {
    self.categorias = data.results
    self.loadPlanes({})
  })

  UserService.get().$promise.then(function(data) {
    self.responsables = data.results
  })

  self.onCategoriaChange = function() {
    var params = { categoria_id: self.atencion.categoria_id }
    self.loadPlanes(params)
    self.enablePlanes = true
    self.atencion.accion_id = null
    self.onAccionChange()
  }

  self.onAccionChange = function() {
    if (self.atencion.accion_id === null || self.atencion.accion_id === undefined) {
      self.atencion.tarea_id = null
    } else {
      self.tareas = self.planes_dict[self.atencion.accion_id].tareas
      self.atencion.tarea_id = "" + self.tareas[0]["id"]
    }
  }

  self.agendarEvento = function() {
    var post_data = {
      tarea_id: self.atencion.tarea_id,
      sesiones: self.atencion.sesiones.map(function(sesion) {
        return {
          responsable_id: sesion.responsable_id,
          fecha_limite: $filter("date")(sesion.fecha_limite, "yyyy-MM-dd")
        }
      }),
      notificar_responsable: self.notificarResponsable,
      comentario: self.comentario,
      marcar_realizado: self.marcarRealizado,
      registra_asistencia: true,
      asistencia: self.marcarRealizado
    }

    self.isLoading = true
    saveCallback(post_data, function() {
      self.isLoading = false
      self.closeFormulario()
    })
  }

  self.cancelarEvento = function() {
    self.closeFormulario()
  }

  self.closeFormulario = function() {
    $mdDialog.hide()
  }
}

FormularioEliminarAtencionesController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioEliminarAtencionesController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminarAtenciones = function() {
    saveCallback()
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}
